// mall 微服务接口
import request from '@/utils/request'
import base from '@/api/base'
const mallApi = {
    queryNewProductCount: base.api + '/family/mall/new/na/dashboard/queryNewProductCount', // 查询本月新增资源
    queryProductCount: base.api + '/family/mall/new/na/dashboard/queryProductCount', // 查询网站累计资源的数量

    queryLoginUserCount: base.api + '/family/mall/new/na/dashboard/queryLoginUserCount', // 查询登录过系统的人数
    queryProductCountRankByCompany: base.api + '/family/mall/new/na/dashboard/queryCompanyPublishRank', // 企业贡献资源排行
    queryProductDownloadCountRankByCategory: base.api + '/family/mall/new/na/dashboard/queryProductDownloadCountRankByCategory', // 热门下载分类排行
    queryKeywordRanking: base.api + '/family/mall/new/na/dashboard/queryKeywordRanking', // 查询用户搜索关键词热度排行
}

/**
 * 查询今日新增资源
 * @returns
 */
export const getQueryNewProductCount = () => {
    return request({
        url: mallApi.queryNewProductCount,
        method: 'post',
    })
}
/**
 * 查询网站累计资源的数量
 * @returns
 */
export const getqueryProductCount = () => {
    return request({
        url: mallApi.queryProductCount,
        method: 'post',
    })
}
/**
 * 查询登录过系统的人数
 * @returns
 */
export const getqueryLoginUserCount = () => {
    return request({
        url: mallApi.queryLoginUserCount,
        method: 'post',
    })
}
/**
 * 企业贡献资源排行
 * @returns
 */
export const getqueryProductCountRankByCompany = (data) => {
    return request({
        url: mallApi.queryProductCountRankByCompany,
        method: 'post',
        data
    })
}
/**
 * 热门下载分类排行
 * @returns
 */
export const getqueryProductDownloadCountRankByCategory = () => {
    return request({
        url: mallApi.queryProductDownloadCountRankByCategory,
        method: 'get',
    })
}

/**
 * 查询用户搜索关键词热度排行
 * @returns
 */
export const getqueryKeywordRanking = (data) => {
    return request({
        url: mallApi.queryKeywordRanking,
        method: 'post',
        data
    })
}